module.exports = __webpack_public_path__ + "img/carshina22_21.31d28b9e.jpg";